import { render } from "./all-monitoring-pembelajaran-peserta.vue?vue&type=template&id=197b1b74"
import script from "./all-monitoring-pembelajaran-peserta.vue?vue&type=script&lang=js"
export * from "./all-monitoring-pembelajaran-peserta.vue?vue&type=script&lang=js"

import "./all-monitoring-pembelajaran-peserta.vue?vue&type=style&index=0&id=197b1b74&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__